import React from "react";
import { Link } from "react-router";

import styles from "./SubmitContactForm.module.scss";

const SubmitContactForm: React.FC = () => {
  return (
    <div className={styles.submit}>
      <div className={styles.checkbox}>
        <input type="checkbox" name="personalDataConsent" required />
        <p>
          Я даю согласие на <Link to="/policy">обработку моих персональных данных</Link> и принимаю условия{" "}
          <Link to="/privacy">политики конфиденциальности</Link>
        </p>
      </div>
      <button type="submit">Отправить</button>
    </div>
  );
};

export default SubmitContactForm;
